import { ReportTask } from '@nx-smartmonkey/shared/domain';
import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import * as routing from '../../../../../../../constants/Routing';
import { Route } from '../../../../../../../domain/route/Route';
import { Stop } from '../../../../../../../domain/stop/Stop';
import { StopTask } from '../../../../../../../domain/stop/StopTask';
import { useRetrieveDriverCredentials } from '../../../../../hooks/useRetrieveDriverCredentials';
import { useRetrieveVehicle } from '../../../../../hooks/useRetrieveVehicle';
import { useRouteContext } from '../../../../context/context';
import { StopComplete } from './StopComplete';
import { StopCompleteTasks } from './tasks/StopCompleteTasks';

interface StopCompleteContainerProps {
  stop: Stop;
  selectedRoute: Route;
  onClose: (stopId: string) => void;
  onComplete: (stopId: string | undefined) => void;
}

export const StopCompleteContainer = ({ stop, selectedRoute, onClose, onComplete }: StopCompleteContainerProps) => {
  const navigate = useNavigate();
  const { data: vehicleData } = useRetrieveVehicle();
  const { data: credentials } = useRetrieveDriverCredentials();
  const [reportTasks, setReportTasks] = useState<Array<ReportTask>>([]);
  const [temporalReportTasks, setTemporalReportTasks] = useState<Array<ReportTask>>([]);
  const [temporalTasks, setTemporalTasks] = useState<Array<StopTask>>([]);
  const [showTasks, setShowTasks] = useState<boolean>(
    !!vehicleData?.project.tasks_enabled && !!(stop.tasks.length > 0 || credentials?.test(`can_update_stop_tasks`))
  );
  const { routeState } = useRouteContext();

  useEffect(() => {
    if (
      stop.report ||
      (vehicleData?.project.fields.configuration.includes(`stop_duration`) && routeState.startedReportStop !== stop.id)
    ) {
      navigate(routing.PRIVATE_ROUTES.STOP_DETAILS.replace(`:routeId`, selectedRoute.id).replace(`:stopId`, stop.id));
      return;
    }
    const mappedReportTasks = [] as Array<ReportTask>;

    stop.tasks.forEach((task) =>
      mappedReportTasks.push(
        ReportTask.create({
          task_id: task.id,
          status: `pending`,
        })
      )
    );

    setReportTasks(mappedReportTasks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClose = () => {
    if (
      vehicleData?.project.tasks_enabled &&
      (credentials?.test(`can_update_stop_tasks`) || reportTasks.length > 0 || temporalReportTasks.length > 0)
    ) {
      setShowTasks(true);
    } else {
      onClose(stop.id);
    }
  };

  return (
    <>
      <StopCompleteTasks
        show={showTasks}
        stop={stop}
        onClose={(stopId: string) => {
          // Add the required argument
          setShowTasks(false);
          onClose(stopId);
        }}
        onComplete={(reportTasks, temporalReportTasks, temporalTasks) => {
          setShowTasks(false);
          setReportTasks(reportTasks);
          setTemporalReportTasks(temporalReportTasks);
          setTemporalTasks(temporalTasks);
        }}
      />
      <StopComplete
        stop={stop}
        selectedRoute={selectedRoute}
        reportTasks={reportTasks}
        temporalReportTasks={temporalReportTasks}
        temporalTasks={temporalTasks}
        onClose={handleOnClose}
        onComplete={onComplete}
      />
    </>
  );
};
